import {z} from "zod";

export const mediaSchema = z.object({
    items: z.array(z.string()),
    display: z.enum(["portrait", "landscape"]),
});

export type Media = z.infer<typeof mediaSchema>;

export const logoSchema = z.union([
    z.string(),
    z.object({
        light: z.string(),
        dark: z.string(),
    }),
]);

export type Logo = z.infer<typeof logoSchema>;